<svg height="100%" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M27.9546 9.02728C31.3532 10.7266 33.5 14.2002 33.5 18C33.5 21.7998 31.3532 25.2734 27.9546 26.9727L17.0182 32.4409C15.6252 33.1374 14.0892 33.5 12.5318 33.5C6.99139 33.5 2.5 29.0086 2.5 23.4682L2.5 12.5318C2.5 6.99139 6.9914 2.5 12.5318 2.5C14.0892 2.5 15.6252 2.8626 17.0182 3.55909L27.9546 9.02728Z"
    class="background"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18 11.9395L24.0607 18.0001L18 24.0608L16.9393 23.0001L21.1893 18.7501H12.25V17.2501H21.1893L16.9393 13.0001L18 11.9395Z"
    class="foreground"
  />
</svg>
